import { QuizBuilderSteps } from '@repo/types/enums/quizBuilderSteps';

export const quizBuilderNavigationSteps = [
  {
    label: 'Dane',
    to: QuizBuilderSteps.BASIC_INFO,
  },
  {
    label: 'Pytania',
    to: QuizBuilderSteps.QUESTIONS,
  },
  {
    label: 'Opcje',
    to: QuizBuilderSteps.SETTINGS,
  },
];
